"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_chart__line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "chart-line-hi"), /*#__PURE__*/React.createElement("g", {
    id: "d1d6cef7-e9ee-4bda-9d17-ab6ed29d3d36",
    "data-name": "line-chart-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "48db194f-348d-4c3c-a7c6-e5748026016d",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1c43b66d-c219-458e-baca-cbbbe75e5420",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2e2add7-c5f8-4205-8fa7-f7c9195051dc",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "66edd9cd-83fe-4265-8e1b-432dd247336d",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7bf4cc79-06f4-4006-be55-a59293672365",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a960f9ba-be9c-4470-ad5a-508604d0df6a",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "762f6f49-42f6-4c88-ae44-7b1af16f45c4",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "957a8d60-f084-41c7-ad96-f5468bd8af9c",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8fa79c79-1442-47a2-b38c-bef7fd914905",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8a2eca00-d64f-4b3c-9810-02cf949ce5f4",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "34186ab4-7d6d-489b-b689-358ee2c864c6",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e0c63c95-a9ec-4549-82c1-195b0ed6f46f",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "91b3a7c8-9835-4cec-ab92-2c37455be684",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dfc7e617-32c4-454d-a9ac-a44c4ddc1b01",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "658cda54-91e1-45b9-a7d9-f56c8e001a8f",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d2484978-d76a-4cd6-aa93-be6a6e7dc411",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "68bdaf02-a2fe-4070-acd0-4570a5c19836",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "29ea7a08-4c02-43a2-8dda-b7449152b02a",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "575346ec-c2cc-4912-856e-08a59672dd29",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1c43b10-f01c-4629-a9b6-a2de82e99530",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ca43da85-6a4e-4caa-9ae5-3b1f690b1385",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 144,
    height: 144,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,138V54a2,2,0,0,1,4,0v84a2,2,0,0,1-4,0Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "61.13 114.5 73 102.54 80 107.69 104 76.31 117 94.61 137.38 82.75",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "61.13 114.5 73 102.54 80 107.69 104 76.31 117 94.61 137.38 82.75",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,140H50a2,2,0,0,1,0-4h92a2,2,0,0,1,0,4Z",
    fill: "#4a4d4e"
  }))))))))))))))))))))))));
}

var _default = ic_chart__line;
exports.default = _default;